// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "OldSelect__textCenter__ilkT1";
export const select = "OldSelect__select__ye7e9";
export const isDisabled = "OldSelect__isDisabled__gFjB9";
export const autosuggest = "OldSelect__autosuggest__Jd83o";
export const isLoading = "OldSelect__isLoading__fALeN";
export const noResults = "OldSelect__noResults__AZ+fr";
export const dropdownItems = "OldSelect__dropdownItems__bZ7+3";
export const isDropdownShown = "OldSelect__isDropdownShown__LOFOd";
export const items = "OldSelect__items__DclK7";
export const dark = "OldSelect__dark__SekDV";
export const isAboveInput = "OldSelect__isAboveInput__qj-eP";
export const withBorder = "OldSelect__withBorder__-UnSs";
export const isFirefox = "OldSelect__isFirefox__EiJDR";
export const item = "OldSelect__item__mjVV8";
export const itemHighlighted = "OldSelect__itemHighlighted__vsKWt";
export const searchTextboxIcon = "OldSelect__searchTextboxIcon__aqMQm";
export const clearInput = "OldSelect__clearInput__seEYC";
export const roundFrame = "OldSelect__roundFrame__nNO8P";